import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import { Section, Title } from '../shared';

import { maxWidth } from '../../helpers/media-queries';
import Gallery from './Gallery';

const Wrapper = styled.div `
    position: relative;
    & .screenshots-wrapper {
        &:before, &:after {
            content: '';
            position: absolute;
            top: -20px;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            width: 80px;
            height: 80px;
        }

        &:before {
            background-image: url(./static/images/screenshot/sticker-up-right.png);
            right: -20px;
        }
        
        &:after {
            background-image: url(./static/images/screenshot/sticker-up-left.png);
            left: -20px;
        }
    }

    &:before, &:after {
        content: '';
        position: absolute;
        bottom: -20px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        width: 80px;
        height: 80px;
    }

    &:before {
        background-image: url(./static/images/screenshot/sticker-down-right.png);
        right: -20px;
    }
    
    &:after {
        background-image: url(./static/images/screenshot/sticker-down-left.png);
        left: -20px;
    }

`;

const styles = ({ palette, sizes }) => ({
    root: {
        overflow: 'hidden',

        '& h3': {
            textAlign: 'center',
            color: '#000000',
        },

        '& .wrapper': {        
            position: 'relative',
            borderStyle: 'solid',
            borderWidth: '10px 10px 15px 10px',
            borderImage: 'url(./static/images/screenshot/border.png) 110 139 137 137 fill / 1 / 0 round',

            [maxWidth.lg]: {
                borderWidth: '22px 22px 30px 22px',
            },
    
        },

        '& .screenshots-wrapper': {
            backgroundImage: `
                url(./static/images/screenshot/stain-1.png), 
                url(./static/images/screenshot/stain-2.png), 
                url(./static/images/screenshot/box-pattern.png)
            `,
            backgroundSize: `
                90px auto,
                110px auto,
                125% 300px
            `,
            backgroundColor: '#F9DB53',
            backgroundPosition: `
                35px 25px,
                right 15px,
                bottom center
            `,
            backgroundRepeat: 'no-repeat',

            minHeight: '400px',

            padding: `10px ${sizes.baseSize}px ${sizes.baseSize}px `,

            [maxWidth.lg]: {
                borderWidth: '22px 22px 30px 22px',
            },
            
            [maxWidth.sm]: {
                padding: '25px 0',

                backgroundImage: `
                    url(./static/images/screenshot/box-pattern.png)
                `,
                backgroundSize: `
                    125% 300px
                `,
                backgroundPosition: `
                    bottom center
                `,
            },
        }
    }
});

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    screenshots: stores.screenshots.screenshots,
})

class Screenshots extends Component {
    render() {
        const { intl, classes } = this.props;
        
        return (
            <Section className={classes.root} id="sesion-capturas">
                <Wrapper className="wrapper">
                    <div className="screenshots-wrapper">
                        <Title>{intl['LOCALE.SCREENSHOTS']}</Title>
                        <Gallery />
                    </div>
                </Wrapper>
            </Section>
        )
    }
}

export default inject(mapper)(
    withStyles(styles)(Screenshots)
);